import api from '../services/api';

/** Télécharge un fichier (xlsx, pdf…) depuis une URL API authentifiée. */
export async function downloadFile(
  url: string,
  filename: string,
  params?: Record<string, any>,
): Promise<void> {
  const response = await api.get(url, { params, responseType: 'blob' });
  const blob = new Blob([response.data], {
    type: response.headers['content-type'] || 'application/octet-stream',
  });
  const href = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = href;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(href);
}
